/**
 * @Author: Daniel Rhees <Daniel>
 * @Date:   2017-04-06T15:38:00-07:00
 * @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-19T16:42:08-07:00
 */


import React, { Component } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { dimensions, spacing, size, type, textColor, leading, borders } from '../../../style';
import Panel from '../../common/Panel';
import Title from '../../common/Title';
import Avatar from '../../common/Avatar';
import Button from '../../blocks/Button';
import TripDates from '../../blocks/TripDates';
import Headline from '../../common/Headline';
import Header from '../../blocks/Header';
import { Link } from 'react-router';
import { tsDate, tsSince } from '../../../common';

class UpcomingTrip extends Component {

  // Display CTA version if the user has no upcoming trips.
  renderCTA() {
    return (
      <div className={css(style.ctaBox)}>
        <div className={css(style.ctaMsg)}>
          Create a trip for members to find and join.
        </div>
        <Button to='/trip/create' size='large' variant='primary'>Create a trip</Button>
      </div>
    )
  }

  renderDate(dateVal, right) {
    return (
      <div className={css(style.date, right && style.rightSide)}>{tsDate(dateVal)}</div>
    )
  }

  renderStat(title, value) {
    return (
      <div className={css(style.stat)}>
        <div className={css(style.statVal)}>
          {value}
        </div>
        <div className={css(style.statLabel)}>
          {title}
        </div>
      </div>
    )
  }

  renderContents(contents) {
    return(
      <div className={css(style.container)}>
        <div className={css(style.tripBox)}>
          {contents}
      </div>
      </div>
    )
  }





  render() {

    try {

      let trip = this.props.trip.data[0];

      return (
        this.renderContents(
          <div>
            <pre>
              {/* <code>{JSON.stringify(this.props, null, 4)}</code> */}
            </pre>
            <Header bottomRule={false} size='SM'>
              <Headline>Next upcoming trip</Headline>
            </Header>
              <Panel alwaysBordered>
                <div className={css(style.tripTitle)}>
                  <Title>{trip.city}, {trip.country}, {trip.region}</Title>
                </div>
                <TripDates leaveDt={trip.leaving_dt.date} returnDt={trip.returning_dt.date} />
                <div className={css(style.divider)}></div>
                <div className={css(style.statRow)}>
                  <Link to={`/trip/${trip.id}`} >
                    {this.renderStat('Asked to join', trip.likes)}
                  </Link>
                </div>
              </Panel>
          </div>
        )
      );
    } catch(e) {
      return (
        this.renderContents(this.renderCTA())
      )
    }

  }
}

const style = StyleSheet.create({
  ctaBox: {
    ...spacing.PADDING_V_XL,
    border: borders.DEFAULT,
    borderRadius: 3,
    textAlign: 'center',

    [dimensions.SCREEN_MAX_SM]: {
      ...spacing.MARGIN_SM,
    }
  },

  ctaMsg: {
    ...spacing.MARGIN_H_MD,
    ...spacing.MARGIN_BOTTOM_MD,
    ...type.title.XS,
  },

  tripBox: {
    [dimensions.SCREEN_MAX_SM]: {
      ...spacing.MARGIN_MD
    }
  },

  tripTitle: {
    ...spacing.MARGIN_BOTTOM_SM
  },

  tripDates: {
    display: 'table',
    width: '100%'
  },

  date: {
    display: 'table-cell',
    width: '45%',
    ...type.LG,
    ...textColor.NORMAL
  },

  rightSide: {
    textAlign: 'right'
  },

  dateSeperator: {
    textAlign: 'center',
    display: 'table-cell',
    verticalAlign: 'middle'
  },

  divider: {
    borderBottom: borders.DEFAULT,
    ...spacing.PADDING_BOTTOM_SM,
    ...spacing.MARGIN_BOTTOM_SM
  },

  statRow: {
    display: 'flex',
    justifyContent: 'space-around'
  },

  stat: {
    textAlign: 'center'
  },

  statVal: {
    ...type.title.LG,
    fontWeight: '300'
  }
})

export default UpcomingTrip;



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/UpcomingTrip.jsx